package io.archisource.shared

import kotlinx.serialization.Serializable

@Serializable
data class CurrentUserDto(
    val authenticated: Boolean,
    val subject: String? = null,
    val applicationUserId: String? = null,
    val username: String? = null,
    val displayName: String? = null,
    val email: String? = null,
    val givenName: String? = null,
    val familyName: String? = null,
    val roles: Set<String> = emptySet(),
    val permissions: Set<String> = emptySet(),
    val attributes: Map<String, List<String>> = emptyMap(),
)
